import { Button, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnGroup, BtnToolbar } from '@dec/shared';
import { ConfirmDialog } from 'app/core/dialog';
import { notificationSuccess } from 'app/core/toast';
import { useSpinnerActions } from 'app/layouts/store';
import { type CatalogModel } from '../../configuration/catalogs/models/Catalog';
import { label as labelCommon } from 'app/modules/translation';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { StringParam, useQueryParams } from 'use-query-params';

import { FormPaymentDeclaration } from '../components/FormPaymentDeclaration';
import { TaxReturnPaymentSummary } from '../components/TaxReturnPaymentSummary';
import {
  useGetTaxreturnByCurrentTaxpayer,
  useGetTaxreturnPaymentByCurrentTaxpayer
} from '../hooks/useGetTaxreturnByCurrentTaxpayer';
import { paymentService } from '../services/payment.service';

export const RejectPaymentPage = () => {
  const [parameters, setParameters] = useQueryParams({
    taxReturnId: StringParam,
    paymentId: StringParam
  });
  const { loading, taxreturn, error } = useGetTaxreturnByCurrentTaxpayer(
    parameters?.taxReturnId as string
  );
  const {
    loading: loadingPayment,
    error: errorPayment,
    data: payment
  } = useGetTaxreturnPaymentByCurrentTaxpayer(parameters?.paymentId as string);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showSpinner, hideSpinner } = useSpinnerActions();

  if (loading || error || loadingPayment || errorPayment) {
    return <></>;
  }
  if (taxreturn === undefined || payment === undefined) {
    return (
      <div className="h-25">
        <div className="d-flex align-self-center align-items-center justify-content-center">
          <div>{t('common.label.noFound')}</div>
        </div>
      </div>
    );
  }

  const onCancel = () => {
    navigate(-1);
  };

  const onSubmit = async (data: any) => {
    const ok = await ConfirmDialog({
      titleModal: t('common.dialog.warning-title'),
      message: t('common.messages.confirm'),
      okButton: labelCommon('ok'),
      cancelButton: labelCommon('cancel')
    });

    if (ok) {
      const request = {
        reason: data.reason
      } as any;

      showSpinner();
      try {
        await paymentService.rejectPayment(payment.id as string, request);
        notificationSuccess(t('common.message.savedSucessfully'));
        navigate(`/taxpayer/taxreturn-payment`);
      } finally {
        hideSpinner();
      }
    }
  };

  return (
    <>
      <PageTitle title={t('common.label.payment')} />

      <TaxReturnPaymentSummary
        state={payment.state}
        paymentNumber={payment?.paymentNumber}
        taxReturn={taxreturn}
      />

      <FormPaymentDeclaration
        reject={true}
        initialValues={{
          amount: payment.amount,
          paymentMethod: payment.paymentMethod as CatalogModel,
          currency: payment.currency as CatalogModel,
          paymentDate: payment.paymentDate,
          attachment: payment.attachmentId
            ? { id: payment.attachmentId, name: `${taxreturn.taxReturnNumber}.pdf` }
            : undefined,
          reference: payment.paymentReference,
          swift: payment.swift,
          state: payment.state,
          reject: true
        }}
        readOnly={true}
        nameForm="payment"
        onSubmit={onSubmit}
      />
      <BtnToolbar>
        <BtnGroup>
          <Button action={ButtonAction.return} variant="secondary" onClick={onCancel} />
        </BtnGroup>
        <BtnGroup>
          <BtnGroup>
            <Button
              text={t('taxpayer-request-val.label.reject')}
              type="submit"
              variant="primary"
              form="payment"
            />
          </BtnGroup>
        </BtnGroup>
      </BtnToolbar>
    </>
  );
};
